import { env } from 'env';

const { REACT_APP_CLIENT_ENV } = env;

export const REACTIONS =
  REACT_APP_CLIENT_ENV === 'EK'
    ? [
        'cooldance',
        'agreeing',
        'thumbsdown',
        'waving',
        'waving2',
        'clap',
        'raisehand',
      ]
    : ['waving', 'clap', 'agreeing', 'victory', 'waving2', 'cooldance'];
